module.exports = __webpack_public_path__ + "assets/img/ALMACENESPAA.b0170290.svg";